import PlaceSelect from "@/components/form/place-select";
import {
  makePickerField,
  type PickerFieldProps,
} from "@/fields/_internal/make-picker-field";

/** **Value is a place id** (`string | null`). */
export type PlaceFieldProps = PickerFieldProps<string | null>;

export const PlaceField = makePickerField<string | null>({
  name: "PlaceField",
  control: PlaceSelect,
});
